import CompensationExtend from "pages/CompensationExtend/CompensationExtend";

export default CompensationExtend